import React, { useEffect, useState } from 'react';
import List from './List';
import Edit from './Edit';
import { useParams, useSearchParams } from 'react-router-dom';
import {
  FilterBox,
  PageHeader,
  PageAction,
  PrimaryButton,
  PrimaryPage,
} from '@/Theme';
import { PatientService } from '@/Services';

const Home = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [listData, setListData] = useState([]);
  const [filter, setFilter] = useState({ search: "" });
  const [search, setSearch] = useState('');
  const [count, setCount] = useState(0);
  const [size, setSize] = useState(50);
  const [page, setPage] = useState(1);
  const [sort, setSort] = useState('updated');
  const [direction, setDirection] = useState('desc');
  //For editing
  const [openDrawer, setOpenDrawer] = useState(false);
  const [drawer, setDrawer] = useState('');
  const [selectedItem, setSelectedItem] = useState({});

  const filters = {
    where: {},
    size: size,
    page: page,
    sort: sort,
    order: direction,
  };
  const fetch = async () => {
    if (!listData.length) {
      setLoading(true);
    }
    filters.where = filter;
    let response = await PatientService.search(filters);
    if (response && response.data && response.data.objects) {
      const objects = response.data.objects;
      setListData(objects);
      setCount(response.data.count);
    }
    setLoading(false);
  };
  useEffect(() => {
    console.log('### fetch test types', search, size, page, sort, direction);
    filter.where = { freeText: search };
    fetch();
  }, [filter, size, page, sort, direction]);

  const onSearchChange = (e) => {
    e.preventDefault();
    setSearch(e.target.value);
  };
  const onSearchPressed = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      let updatedFilter = { ...filter, ...{ search: e.target.value } };
      setFilter(updatedFilter);
    }
  };
  const handleEdit = (item) => {
    setSelectedItem(item);
    setDrawer('new');
    setOpenDrawer(true);
  };
  const handleNew = () => {
    setSelectedItem({});
    setDrawer('new');
    setOpenDrawer(true);
  };
  const contentDrawer = () => {
    let drawerContent = '';
    if (openDrawer) {
      if (drawer === 'new') {
        drawerContent = (
          <Edit
            openDrawer={openDrawer}
            setOpenDrawer={setOpenDrawer}
            selectedItem={selectedItem}
            refreshList={fetch}
            inputVariables={filters}
          />
        );
      }
    }
    return drawerContent;
  };
  return (
    <PrimaryPage title='Patients'>
      <PageHeader>
        <PageAction>
          <FilterBox
            value={search}
            onChange={onSearchChange}
            onPress={onSearchPressed}
          />
        </PageAction>
        {/* <PrimaryButton onClick={handleNew}>New Patient</PrimaryButton> */}
      </PageHeader>
      <List
        listData={listData}
        setOpenDrawer={setOpenDrawer}
        handleEdit={handleEdit}
        loading={loading}
        count={count}
        size={size}
        setSize={setSize}
        page={page}
        setPage={setPage}
        sort={sort}
        setSort={setSort}
        direction={direction}
        setDirection={setDirection}
      />
      {contentDrawer()}
    </PrimaryPage>
  );
};
export default Home;
